import { EMPTY_STR } from '../constants/common';
import { DATA_ATTRIBUTES_KEYS, DATA_TAG } from '../constants/tracking';

/**
 * obj: Dataset html attribute object
 * Takes the dataset object, and removes anything not supported by the datalayer attribute keys
 **/
const filterObject = (obj: Record<string, string | undefined>) => {
    const ret: Record<string, string> = {};
    for (const [_, value] of Object.entries(DATA_ATTRIBUTES_KEYS)) {
        // Skip the TEST_ID attribute since it's only used for testing and shouldn't be included in the datalayer
        if (value === DATA_ATTRIBUTES_KEYS.TEST_ID) {
            continue;
        }
        const newKey = value.replace(DATA_TAG, EMPTY_STR).replaceAll(/-([a-z])/g, function (g) {
            return g[1].toUpperCase();
        });
        const objectValue = obj[newKey];
        if (objectValue) {
            Object.assign(ret, { [newKey]: objectValue });
        }
    }

    return ret;
};

export { filterObject };
